import React from 'react'
import Slider from '../../slider'
import _ from 'lodash'

const CaratSlider = (props) => {
  const valToPos = val => {
    return Math.cbrt(val * 5)
  }

  const posToVal = position => {
    const raw = Math.pow(position, 2) * (position / 5)
    // due to the deviation caused by the formula above, just return the MAX number if the result for 'raw' is equal or greater than it
    if (raw >= props.max) {
      return props.max
    }
    return _.round(raw, 2)
  }

  return (
    <Slider {...props} mapValues={{valToPos, posToVal}} />
  )
}

export default CaratSlider



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/primary-diamond-panel/carat-slider.js